import React, { useState, useEffect } from "react";

// import Select from "react-select";
import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
require("react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css");
import filterFactory, {
  textFilter,
  // selectFilter,
} from "react-bootstrap-table2-filter"; // , {textFilter, selectFilter, dateFilter,}
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { toast } from "react-toastify";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
import { Row, Col, Form, Button, FormControl } from "react-bootstrap";
// import { CSVLink } from "react-csv";
// const { SearchBar } = Search;

// Import Service
import assocService from "../../services/assoc.service";
import authService from "../../services/auth.service";
import farmerService from "../../services/farmer.service";
import dashboardService from "../../services/dashboard.service";

//Import Modal
// import Modalapprove from "./Modalapprove";

//Import Loading
// import Spinner from "react-bootstrap/Spinner";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

//Import tooltip
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

//Import Loading
import LoadingAlert from "../../components/LoadingAlert";

import "./association.css";
// Import Modal
import ModalViewMember from "./modalViewMember";
import ModalEditMember from "./modalEditMember";
import ModalCheckMember from "./modalCheckMember";
import ModalViewAssoc from "../AdminDashboard/modalViewAssoc";
import MemberForm from "./formMember";
import FarmerForm from "./formFarmer";

const AssociationMembers = () => {
  const [loading, setLoading] = useState(false);
  // const [loadingAlert, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [memberdata, setMemberData] = useState([]);
  const [assocdata, setAssocdata] = useState([]);
  const [showFormCheck, setShowFormCheck] = useState(false);
  const [showMemberForm, setShowMemberForm] = useState(false);
  const [showAddfarmer, setShowAddfarmer] = useState(false);
  // const [assocName, setAssocName] = useState("");
  const [assocMember, setAssocMember] = useState({});
  const [farmer, setFarmer] = useState({});
  const [assoc, setAssoc] = useState({});
  const [assocFilter, setAssocFilter] = useState([]);
  const [show_view, setShow_view] = useState(false);
  const [show_edit, setShow_edit] = useState(false);
  const [show_assoc, setShow_assoc] = useState(false);
  // const [user_id, setUser_id] = useState(0);
  // const [user_type, setUser_type] = useState(0);
  // const [show, setShow] = useState(false);
  // const [farmerselect, farmerSetselect] = useState({});
  const [search, setSearch] = useState({});
  // const [textSearch, setTextSearch] = useState("");
  // const [statusSearch, setStatusSearch] = useState("");
  // const [masterSearch, setMasterSearch] = useState("");
  // const [regSearch, setRegSearch] = useState("");
  // const [dopaSearch, setDopaSearch] = useState("");
  const { ExportCSVButton } = CSVExport;

  const user = authService.getCurrentUser();

  useEffect(() => {
    // setTextSearch();
    // setStatusSearch();
    // setMasterSearch();
    // setRegSearch();
    // setDopaSearch();
    // setSearch({
    //   ...search,
    //   assoc_id: user.user.user_assoc,
    //   textSearch: textSearch,
    // });
    // if (user.user.member_type === 4) {
    //   setSearch({
    //     ...search,
    //     assoc_id: user.user.user_assoc,
    //   });
    //   getMemberData(user.user.user_assoc, search);
    // }
    if (user.user.member_type === 4) {
      // setSearch({
      //   assocSearch: user.user.user_assoc,
      //   search: "",
      // });z
      getMemberData({
        assocSearch: user.user.user_assoc,
      });
    }
    getAssoc();
    getAssocFilter();
    // getMemberData();
    // setSearch();
    // getAssocName(user.user.user_assoc);
  }, [user.user.user_assoc]);

  const getFarmer = (farmer_idcard) => {
    farmerService.getFarmerById(farmer_idcard).then((response) => {
      setFarmer(response.data.farmer);
    });
  };

  const getAssoc = (e) => {
    // console.log(user.user.user_assoc);
    if (e && user.user.member_type === 6) {
      assocService.getAssociationById(e).then((response) => {
        setAssoc(response.data.data);
      });
    } else if (user.user.member_type === 4) {
      assocService.getAssociationById(user.user.user_assoc).then((response) => {
        setAssoc(response.data.data);
      });
    }
  };

  const getMemberData = (search) => {
    console.log(search);
    setLoading(true);
    // console.log(user.user.member_type);
    if (user.user.member_type === 4) {
      setSearch({
        ...search,
        assocSearch: user.user.user_assoc,
        // textSearch: "",
      });
      assocService
        .getMembersByAssoc(search)
        .then((response) => {
          console.log(response);
          setMemberData(response.data.data);
        })
        .catch((error) => {
          console.error("error fetching data: ", error);
          setError(error);
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (
      user.user.member_type === 5 ||
      user.user.member_type === 6 ||
      user.user.member_type === 8
    ) {
      // console.log(user.user.member_type);
      assocService
        .getAllMembers(search)
        .then((response) => {
          // console.log(response);
          setMemberData(response.data.data);
        })
        .catch((error) => {
          console.error("error fetching data: ", error);
          setError(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
    // console.log(memberdata);
  };

  const clickCheckMember = () => {
    console.log("clickCheckMember");
    setShowFormCheck(true);
  };

  const clickDeleteMember = (row) => {
    // console.log(row);
    setLoading(true);
    confirmAlert({
      title: "",
      message: "ต้องการลบใช่หรือไม่",
      buttons: [
        {
          label: "ใช่",
          onClick: () => {
            assocService
              .deleteMember(row.memberid)
              .then((response) => {
                if (response.data.success) {
                  setMemberData((data) =>
                    data.filter((a) => a.memberid != row.memberid)
                  );
                }
              })
              .catch((error) => {
                console.error("error fetching data: ", error);
                setError(error);
              })
              .finally(() => {
                setLoading(false);
              });
          },
        },
        {
          label: "ไม่ใช่",
          onClick: () => false,
        },
      ],
      overlayClassName: "confirm-alert-2button",
    });
  };

  const clickAddMember = (form) => {
    // console.log(form[0].search);
    getFarmer(form.search);
    getAssoc(form.assoc);
    setShowFormCheck(false);
    setShowMemberForm(true);
    // alert(JSON.stringify(form));
  };

  const clickNewFarmer = (form) => {
    getFarmer(form.search);
    setShowFormCheck(false);
    setShowAddfarmer(true);
    // alert(JSON.stringify(form));
  };

  const clickViewData = (row) => {
    // console.log("View");
    setAssocMember(row);
    setShow_view(true);
  };

  const ActionsView = (row) => {
    return (
      <>
        <i
          className="bi bi-search custom-icon-table"
          onClick={() => clickViewData(row.row)}
        ></i>
      </>
    );
  };

  const clickViewAssoc = (id) => {
    console.log(id);
    setAssocdata([]);
    setLoading(true);
    dashboardService
      .getAssocByFarmer(id)
      .then((response) => {
        console.log(response.data.data);
        setAssocdata(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
    setShow_assoc(true);
  };

  const actionsViewAssoc = (cell, row) => {
    // console.log(row);
    return (
      <>
        <a onClick={() => clickViewAssoc(row.cardid)}>{cell}</a>
      </>
    );
  };

  const clickEditMember = (row) => {
    setAssocMember(row);
    console.log(assocMember);
    // setUser_id(user.user.user_id);
    setShow_edit(true);
  };

  // const handleSearchChange = (e) => {
  //   // console.log(e.target.value);
  //   setTextSearch(e.target.value);
  // };
  // const handleSearchStatusChange = (e) => {
  //   // console.log(e.target.value);
  //   setStatusSearch(e.target.value);
  // };
  // const handleSearchMasterChange = (e) => {
  //   // console.log(e.target.value);
  //   setMasterSearch(e.target.value);
  // };
  // const handleSearchDopaChange = (e) => {
  //   // console.log(e.target.value);
  //   setDopaSearch(e.target.value);
  // };
  const handleSearch = (e) => {
    e.preventDefault();
    getMemberData(search);
  };

  const setField = (field, value) => {
    setSearch({
      ...search,
      [field.name]: value,
    });
  };

  // const confirmMessage = (row) => {
  //   return (
  //     <>
  //       สมาชิก : [{row.farmercardid}] {row.membmername}
  //       <br />
  //       สมาคม : {row.assocname} <br />
  //       <hr />
  //     </>
  //   );
  // };

  // const clickAddMaster = (row) => {
  //   confirmAlert({
  //     title: <h6>ยืนยันการเป็นหัวหน้ากลุ่ม</h6>,
  //     message: confirmMessage(row),
  //     buttons: [
  //       {
  //         label: "ยกเลิก",
  //         onClick: () => false,
  //       },
  //       {
  //         label: "ยืนยัน",
  //         onClick: () => {
  //           academyService
  //             .newMaster(row.assoc_member_id)
  //             .then((response) => {
  //               if (response.data.success) {
  //                 setMemberData(
  //                   data.filter((a) => a.assoc_member_id != row.assoc_member_id)
  //                 );
  //               }
  //             })
  //             .catch((error) => {
  //               console.error("error fetching data: ", error);
  //               setError(error);
  //             })
  //             .finally(() => {
  //               setLoading(false);
  //             });
  //         },
  //       },
  //     ],
  //     overlayClassName: "confirm-alert-2button",
  //   });
  // };

  const ActionsEdit = (row) => {
    return (
      <>
        {/* <i
          className="bi bi-file-earmark-person custom-icon-table"
          onClick={() => clickViewData(row.row)}
        ></i> */}
        <i
          className="bi bi-search custom-icon-table"
          onClick={() => clickViewData(row.row)}
        ></i>
        <i
          className="text-info bi bi-pencil custom-icon-table"
          onClick={() => clickEditMember(row.row)}
          title="แก้ไขข้อมูล"
        ></i>
        {row.row.statusmember === "พ้นสภาพ" ||
        row.row.statusmember === "ลาออก" ? (
          <i
            className="bi bi-person-dash custom-icon-table"
            onClick={() => clickDeleteMember(row.row)}
            style={{ color: "red" }}
            title="ถอนการเป็นสมาชิก"
          ></i>
        ) : (
          ""
        )}
      </>
    );
  };

  const onSubmitSave = (e) => {
    const formdata = {
      ...e,
      association_id: user.user.user_assoc ? user.user.user_assoc : e.assoc_id,
      user_id: user.user.user_id,
    };
    // console.log(formdata);
    setLoading(true);
    assocService
      .createMember(formdata)
      .then((response) => {
        console.log(response.data);
        if (response.data.success) {
          setMemberData([response.data.data, ...memberdata]);
          // console.log(memberdata);
        }
      })
      .catch((error) => {
        console.error("error add data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
        setShowMemberForm(false);
        // setMemberData([]);
      });
  };

  const actionsViewFormatter = (cell, row) => {
    if (user.user.member_type === 4 || user.user.member_type === 6) {
      return <ActionsEdit row={row} />;
    } else {
      return <ActionsView row={row} />;
    }
  };

  const headerSortingStyle = {
    backgroundColor: "#D4EFDF",
    verticalAlign: "center",
  };

  // const filterStatus = {
  //   อนุมัติ: "อนุมัติ",
  //   รออนุมัติ: "รออนุมัติ",
  // };

  // const filterStatus = {
  //   เป็นสมาชิก: "เป็นสมาชิก",
  //   พ้นสภาพ: "พ้นสภาพ",
  //   ลาออก: "ลาออก",
  // };

  // const filterRegstate = {
  //   ชาวไร่: "ชาวไร่",
  //   พ้นสภาพ: "พ้นสภาพ",
  //   "-": "ไม่มีข้อมูล",
  // };

  // const filterDopaValidate = {
  //   มีชีวิต: "มีชีวิต",
  //   เสียชีวิต: "เสียชีวิต",
  // };

  // const getAssocFilter = () => {
  //   assocService.getAssocList().then((response) => {
  //     console.log(response.data.data);
  //     setAssocFilter(response.data.data);
  //   });
  //   console.log(assocFilter);
  // };

  const getAssocFilter = () => {
    assocService.getAssocList().then((response) => {
      setAssocFilter(response.data.data);
      // console.log(props);
    });
  };

  // const optionApprove = [
  //   { value: "TRUE", label: "ยืนยัน" },
  //   { value: "FALSE", label: "รอยืนยัน" },
  // ];

  const optionStatus = [
    // { value: "รออนุมัติ", label: "รออนุมัติ" },
    { value: "เป็นสมาชิก", label: "เป็นสมาชิก" },
    { value: "รออนุมัติ", label: "รออนุมัติ" },
    { value: "ไม่อนุมัติ", label: "ไม่อนุมัติ" },
    { value: "ลาออก", label: "ลาออก" },
  ];

  const optionRegsurgar = [
    { value: "ชาวไร่", label: "เป็นชาวไร่อ้อย" },
    { value: "ลาออก", label: "ลาออก" },
    { value: "พ้นสภาพ", label: "พ้นสภาพ" },
    { value: "-", label: "ไม่ได้จดทะเบียน" },
  ];

  const optionMaster = [
    { value: "หน.กลุ่ม", label: "หน.กลุ่ม" },
    { value: "สมาชิก", label: "สมาชิก" },
  ];

  const optionDopa = [
    { value: "TRUE", label: "มีชีวิต" },
    { value: "FALSE", label: "เสียชีวิต" },
  ];

  const dopaValidateFormatter = (cell) => {
    if (cell == "มีชีวิต") {
      return <p className="text-success">{cell}</p>;
    } else if (cell == "เสียชีวิต") {
      return <p className="text-danger">{cell}</p>;
    }
  };

  // const selectValidate = {
  //   goodid: "ส่งปกติ",
  //   badid: "ไม่มีการส่ง",
  //   no3yr: "ขาดส่ง",
  //   unclassified: "รอตรวจสอบ",
  // };

  // const statusValidateFormatter = (cell) => {
  //   // console.log(cell.value);
  //   if (cell == "goodid") {
  //     return <p className="text-success">ส่งปกติ</p>;
  //   } else if (cell == "badid") {
  //     return <p className="text-danger">ไม่มีการส่ง</p>;
  //   } else if (cell == "no3yr") {
  //     return <p className="text-warning">ขาดส่ง</p>;
  //   } else {
  //     return <p className="">รอตรวจสอบ</p>;
  //   }
  // };

  const statusFormatter = (cell) => {
    // console.log(cell);
    if (
      cell == "เป็นสมาชิก" ||
      cell == "ชาวไร่" ||
      cell == "มีชีวิต" ||
      cell == "ส่งปกติ"
    ) {
      return <p className="text-success">{cell}</p>;
    } else if (cell == "ลาออก" || cell == "ขาดส่ง") {
      return <p className="text-warning">{cell}</p>;
    } else if (
      cell == "พ้นสภาพ" ||
      cell == "เสียชีวิต" ||
      cell == "ไม่มีการส่ง"
    ) {
      return <p className="text-danger">{cell}</p>;
    } else {
      return <p>{cell}</p>;
    }
  };

  const memberFormatter = (cell) => {
    if (cell == "เป็นสมาชิก") {
      return (
        <OverlayTrigger placement="top" overlay={renderTooltip}>
          <p className="text-success">{cell}</p>
        </OverlayTrigger>
      );
    } else if (cell == "ยืนยัน") {
      return (
        <OverlayTrigger placement="top" overlay={renderTooltip}>
          <p className="text-info">{cell}</p>
        </OverlayTrigger>
      );
    } else if (cell == "รออนุมัติ") {
      return (
        <OverlayTrigger placement="top" overlay={renderTooltip}>
          <p className="text-secondary">{cell}</p>
        </OverlayTrigger>
      );
    } else if (cell == "พ้นสภาพ" || cell == "รอยืนยัน") {
      return (
        <OverlayTrigger placement="top" overlay={renderTooltip}>
          <p className="text-warning">{cell}</p>
        </OverlayTrigger>
      );
    } else if (cell == "ลาออก") {
      return (
        <OverlayTrigger placement="top" overlay={renderTooltip}>
          <p className="text-danger">{cell}</p>
        </OverlayTrigger>
      );
    } else if (cell == "ไม่อนุมัติ") {
      return (
        <OverlayTrigger placement="top" overlay={renderTooltip}>
          <p className="text-danger">{cell}</p>
        </OverlayTrigger>
      );
    }
  };

  const dateFormatter = (cell) => {
    const getdate = new Date(cell);
    return (
      <p>
        {getdate.toLocaleString("th-TH", {
          year: "2-digit",
          month: "short",
          day: "numeric",
        })}
      </p>
    );
  };
  const renderTooltip = (props) =>
    user.user.member_type === 6 ? (
      <Tooltip {...props}>คลิ๊กเพื่อแก้ไขสถานะ</Tooltip>
    ) : (
      <span></span>
    );

  const changeMemberStatus = (body) => {
    console.log(body);
    assocService
      .activateMember(body)
      .then((res) => {
        if (res.data.success) {
          // toast.success(res.data.message);
          // var newArray = memberdata.map(function (el) {
          //   if (el.memberid !== res.data.data.memberid) {
          //     return el;
          //   } else {
          //     var check = res.data.data;
          //     return check;
          //   }
          // });
          // getMemberData();
          // setMemberData([...newArray]);
          toast.success("บันทึกข้อมูลเรียบร้อย !!", {
            position: "bottom-left",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => toast.error(err));
    // if (body.statusmember === "เป็นสมาชิก" || body.statusmember === "ลาออก") {
    //   assocService
    //     .activateMember(body)
    //     .then((res) => {
    //       if (res.data.success) {
    //         // toast.success(res.data.message);
    //         var newArray = memberdata.map(function (el) {
    //           if (el.memberid !== res.data.data.memberid) {
    //             return el;
    //           } else {
    //             var check = res.data.data;
    //             return check;
    //           }
    //         });
    //         getMemberData();
    //         setMemberData([...newArray]);
    //         toast.success("แก้ไขเรียบร้อย !!", {
    //           position: "bottom-left",
    //           autoClose: 1500,
    //           hideProgressBar: false,
    //           closeOnClick: true,
    //           pauseOnHover: true,
    //           draggable: true,
    //           progress: undefined,
    //         });
    //       } else {
    //         toast.error(res.data.message);
    //       }
    //     })
    //     .catch((err) => toast.error(err));
    // } else if (body.statusmember === "TRUE" || body.statusmember === "FALSE") {
    //   assocService
    //     .approveMember(body)
    //     .then((res) => {
    //       if (res.data.success) {
    //         // toast.success(res.data.message);
    //         var newArray = memberdata.map(function (el) {
    //           if (el.memberid !== res.data.data.memberid) {
    //             return el;
    //           } else {
    //             var check = res.data.data;
    //             return check;
    //           }
    //         });
    //         getMemberData();
    //         setMemberData([...newArray]);
    //         toast.success("แก้ไขเรียบร้อย !!", {
    //           position: "bottom-left",
    //           autoClose: 1500,
    //           hideProgressBar: false,
    //           closeOnClick: true,
    //           pauseOnHover: true,
    //           draggable: true,
    //           progress: undefined,
    //         });
    //       } else {
    //         toast.error(res.data.message);
    //       }
    //     })
    //     .catch((err) => toast.error(err));
    // }
  };

  const columns = [
    {
      text: "ID",
      dataField: "memberid",
      isDummyField: true,
      sort: true,
      hidden: true,
      csvExport: false,
    },
    // {
    //   dataField: "statusapprove",
    //   text: "อนุมัติ",
    //   formatter: memberFormatter,
    //   filter: selectFilter({
    //     placeholder: "เลือก",
    //     style: { fontSize: "98%", width: "100%" },
    //     options: filterStatus,
    //   }),
    //   headerStyle: () => {
    //     return { verticalAlign: "middle", width: "8%" };
    //   },
    //   editor: {
    //     type: Type.SELECT,
    //     options: optionApprove,
    //     style: { placeholder: "select", fontSize: "98%" },
    //   },
    //   editable: user.user.member_type === 6 ? true : false,
    // },
    {
      dataField: "statusmember",
      text: "สถานภาพ",
      formatter: memberFormatter,
      // filter: selectFilter({
      //   placeholder: "เลือก",
      //   style: { fontSize: "98%", width: "100%" },
      //   options: filterStatus,
      // }),
      headerStyle: () => {
        return { verticalAlign: "middle", width: "8%" };
      },
      editor: {
        type: Type.SELECT,
        options: optionStatus,
        style: { placeholder: "select", fontSize: "98%" },
      },
      editable: user.user.member_type === 6 ? true : false,
    },
    {
      text: "เลขสมาชิก",
      filter: textFilter({
        placeholder: "ชื่อ-สกุล",
        style: { fontSize: "98%", width: "100%" },
      }),
      dataField: "membercode",
      sort: true,
      headerSortingStyle,
      editable: false,
      headerStyle: () => {
        return {
          verticalAlign: "middle",
          width: user.user.member_type === 6 ? "8%" : "10%",
        };
      },
    },
    {
      text: "สมาชิก",
      filter: textFilter({
        placeholder: "ชื่อ-สกุล",
        style: { fontSize: "98%", width: "100%" },
      }),
      dataField: "membmername",
      sort: true,
      headerSortingStyle,
      editable: false,
      headerStyle: () => {
        return { width: user.user.member_type === 4 ? "20%" : "15%" };
      },
      style: { textAlign: "left" },
    },
    {
      text: "เข้าร่วมสมาคม",
      dataField: "assocsigned",
      hidden:
        user.user.member_type === 4 || user.user.member_type === 6
          ? false
          : true,
      sort: true,
      headerSortingStyle,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "5%" };
      },
      formatter: actionsViewAssoc,
    },
    {
      text: user.user.member_type === 4 ? "บัตรประชาชน" : "สมาคม",
      filter: textFilter({
        placeholder: "ค้นหา",
        style: { fontSize: "98%", width: "100%" },
      }),
      dataField: user.user.member_type === 4 ? "cardid" : "assocname",
      sort: true,
      headerSortingStyle,
      editable: false,
      headerStyle: () => {
        return { width: user.user.member_type === 4 ? "20%" : "25%" };
      },
      style: {
        textAlign: user.user.member_type === 4 ? "" : "left",
      },
    },
    {
      text: "เป็นชาวไร่",
      dataField: "regstatus",
      formatter: statusFormatter,
      // filter: selectFilter({
      //   placeholder: "เลือก",
      //   style: { fontSize: "98%", width: "100%" },
      //   options: filterRegstate,
      // }),
      editable: false,
      headerStyle: () => {
        return {
          verticalAlign: "middle",
          width: user.user.member_type === 6 ? "8%" : "10%",
        };
      },
    },
    {
      text: "เลขชาวไร่",
      dataField: "farmercardid",
      // formatter: statusFormatter,
      // filter: selectFilter({
      //   placeholder: "เลือก",
      //   style: { fontSize: "98%", width: "100%" },
      //   options: filterRegstate,
      // }),
      editable: false,
      headerStyle: () => {
        return {
          verticalAlign: "middle",
          width: user.user.member_type === 6 ? "8%" : "10%",
        };
      },
    },
    {
      text: "หน.กลุ่ม",
      dataField: "membertype",
      editable: false,
      headerStyle: () => {
        return {
          verticalAlign: "middle",
          width: user.user.member_type === 6 ? "8%" : "10%",
        };
      },
    },
    {
      text: "มีชีวิต",
      formatter: dopaValidateFormatter,
      // filter: selectFilter({
      //   placeholder: "เลือก",
      //   style: { fontSize: "98%", width: "100%" },
      //   options: filterDopaValidate,
      // }),
      dataField: "dopavalidate",
      sort: true,
      headerSortingStyle,
      editable: false,
      headerStyle: () => {
        return {
          verticalAlign: "middle",
          width: user.user.member_type === 6 ? "8%" : "10%",
        };
      },
    },
    {
      text: "วันเริ่มเป็นสมาชิก",
      dataField: "createdat",
      formatter: dateFormatter,
      sort: true,
      headerSortingStyle,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle" };
      },
      // filter: dateFilter(),
    },
    {
      text: "แก้ไข",
      dataField: "edit",
      isDummyField: true,
      editable: false,
      formatter: actionsViewFormatter,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "10%" };
      },
      csvExport: false,
    },
    {
      text: "บัตรประชาชน",
      dataField: "cardid",
      isDummyField: true,
      hidden: true,
    },
    {
      text: "รหัสเกษตรกร",
      dataField: "farmercardid",
      isDummyField: true,
      hidden: true,
    },
  ];

  // const headers = [
  //   ...columns.map((a) => {
  //     return { label: a.text, key: a.dataField, csvExport: a.csvExport };
  //   }),
  // ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 10,
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  // if (loading)
  //   return (
  //     <>
  //       <br />
  //       <p>
  //         <Spinner animation="border" variant="success" />
  //         <span>&nbsp;กำลังค้นหาข้อมูล</span>
  //       </p>
  //     </>
  //   );
  if (error) return `Error :${error}`;

  return (
    <div>
      {loading ? <LoadingAlert /> : ""}
      <h3 className="text-center">
        {user.user.member_type === 4 ? (
          <>
            {assoc.association_name_th}
            <hr />
          </>
        ) : (
          ""
        )}
      </h3>
      <ModalCheckMember
        show={showFormCheck}
        hidefunc={(a) => setShowFormCheck(a)}
        onClickAdd={clickAddMember}
        onClickNew={clickNewFarmer}
        assocdata={assoc}
      />
      <MemberForm
        show={showMemberForm}
        hidden_func={(a) => setShowMemberForm(a)}
        farmerdata={farmer}
        assocdata={assoc}
        onsubmit={onSubmitSave}
      />
      <FarmerForm
        show={showAddfarmer}
        hidefunc={(a) => setShowAddfarmer(a)}
        onClickNew={clickNewFarmer}
      />
      <ModalViewMember
        show={show_view}
        data={assocMember}
        setdata={(b) => setMemberData(b)}
        hidden={(a) => setShow_view(a)}
      />
      <ModalEditMember
        show={show_edit}
        data={assocMember}
        memberdata={memberdata}
        setassocmember={(b) => setAssocMember(b)}
        setdata={(b) => setMemberData(b)}
        hidden={(a) => setShow_edit(a)}
        // assoc_selected={assocMember}
      />
      <ModalViewAssoc
        show={show_assoc}
        data={assocdata}
        setdata={(b) => setAssocdata(b)}
        hidden={(a) => setShow_assoc(a)}
      />
      <ToolkitProvider
        bootstrap4
        keyField="memberId"
        data={memberdata}
        columns={columns}
        search
        exportCSV={{
          fileName: "ข้อมูลสมาชิก.csv", // "ข้อมูลสมาชิก_" + {cell} + ".csv",
          separator: ",",
          ignoreHeader: false,
          noAutoBOM: false,
          blobType: "text/plain;charset=utf-8",
          onlyExportFiltered: true,
          exportAll: false,
        }}
      >
        {(prop) => (
          <React.Fragment>
            <div className="text-left"></div>
            <br />
            {/* {JSON.stringify()} */}
            <Row>
              <Col md={9}>
                <Form className="d-flex">
                  <Col md={10}>
                    <Row>
                      {user.user.member_type !== 4 ? (
                        <Col md={6}>
                          <Form.Select
                            size="sm"
                            name="assocSearch"
                            value={search.assocSearch}
                            // onChange={handleSearchStatusChange}
                            onChange={(e) => setField(e.target, e.target.value)}
                          >
                            <option value="">-- สถาบัน --</option>
                            {assocFilter.map((o) => (
                              <option key={o.associd} value={o.associd}>
                                {o.assocname}
                              </option>
                            ))}
                          </Form.Select>
                        </Col>
                      ) : (
                        ""
                      )}
                      <Col md={user.user.member_type !== 4 ? 6 : 12}>
                        <FormControl
                          size="sm"
                          name="textSearch"
                          type="search"
                          placeholder="ชื่อ-สกุล, บัตรประชาชน, เลขสมาชิก"
                          value={search.textSearch}
                          aria-label="Search"
                          // onChange={handleSearchChange}
                          onChange={(e) => setField(e.target, e.target.value)}
                        />
                      </Col>
                      <Col md={3}>
                        <Form.Select
                          size="sm"
                          name="statusSearch"
                          value={search.statusSearch}
                          // onChange={handleSearchStatusChange}
                          onChange={(e) => setField(e.target, e.target.value)}
                        >
                          <option value="">-- สถานะสมาชิก --</option>
                          {optionStatus.map((o) => (
                            <option key={o.value} value={o.value}>
                              {o.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                      <Col md={3}>
                        <Form.Select
                          size="sm"
                          name="regSearch"
                          value={search.regSearch}
                          // onChange={handleSearchDopaChange}
                          onChange={(e) => setField(e.target, e.target.value)}
                        >
                          <option value="">-- ชาวไร่อ้อย --</option>
                          {optionRegsurgar.map((o) => (
                            <option key={o.value} value={o.value}>
                              {o.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                      <Col md={3}>
                        <Form.Select
                          size="sm"
                          name="masterSearch"
                          value={search.masterSearch}
                          // onChange={handleSearchMasterChange}
                          onChange={(e) => setField(e.target, e.target.value)}
                        >
                          <option value="">-- หน.กลุ่ม / สมาชิก --</option>
                          {optionMaster.map((o) => (
                            <option key={o.value} value={o.value}>
                              {o.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                      <Col md={3}>
                        <Form.Select
                          size="sm"
                          name="dopaSearch"
                          value={search.dopaSearch}
                          // onChange={handleSearchDopaChange}
                          onChange={(e) => setField(e.target, e.target.value)}
                        >
                          <option value="">-- มีชีวิต / เสียชีวิต --</option>
                          {optionDopa.map((o) => (
                            <option key={o.value} value={o.value}>
                              {o.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={2}>
                    <Button
                      className="btn btn-info"
                      onClick={handleSearch}
                      style={{
                        padding: ".375rem .75rem",
                        fontSize: "1.5rem",
                      }}
                    >
                      <i className="bi bi-search"></i>
                    </Button>
                  </Col>
                </Form>
              </Col>
              <Col md={3}>
                {/* {user.user.member_type !== 4 ? (
        ) : (
          ""
        )} */}
                {/* <SearchBar {...prop.searchProps} /> */}
                {/* <CSVLink
            data={memberdata}
            headers={[...headers.filter((a) => a.csvExport !== false)]}
            filename={
              user.user.member_type === 4
                ? assoc.association_name_th + ".csv"
                : "ข้อมูลสมาชิกสมาคม.csv"
            }
            className="btn btn-success"
            target="_blank"
            style={{
              padding: ".375rem .75rem",
              fontSize: "1rem",
              float: "right",
            }}
          >
            <i className="bi bi-download"></i>
          </CSVLink> */}
                <ExportCSVButton
                  {...prop.csvProps}
                  style={{
                    padding: ".375rem .75rem",
                    fontSize: "1rem",
                    float: "right",
                  }}
                >
                  <i className="bi bi-download"></i>
                </ExportCSVButton>
                {user.user.member_type === 4 || user.user.member_type === 6 ? (
                  <Button
                    className="btn btn-primary"
                    onClick={clickCheckMember}
                    style={{
                      padding: ".375rem .75rem",
                      fontSize: "1rem",
                      float: "right",
                    }}
                  >
                    เพิ่มสมาชิกสมาคม
                  </Button>
                ) : (
                  ""
                )}
              </Col>
            </Row>
            <BootstrapTable
              // bootstrap4
              keyField="memberid"
              columns={columns}
              data={memberdata}
              pagination={pagination}
              filter={filterFactory()}
              {...prop.baseProps}
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                // beforeSaveCell(oldValue, newValue, row, column, done) {
                //   setTimeout(() => {
                //     if (confirm("ยืนยันการเปลี่ยนแปลง")) {
                //       done(); // contine to save the changes
                //     } else {
                //       done(false); // reject the changes
                //     }
                //   }, 0);
                //   return { async: true };
                // },
                afterSaveCell: (oldValue, newValue, row, column) => {
                  if (oldValue !== newValue) {
                    changeMemberStatus({
                      memberid: row.memberid,
                      statusmember: newValue,
                    });
                  }

                  console.log(oldValue);
                  console.log(newValue);
                  console.log(row);
                  console.log(column);
                  console.log("After Saving Cell!! ");
                },
              })}
            />
          </React.Fragment>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default AssociationMembers;
